export default "__VITE_ASSET__CG2B4WYW__"